import { z } from "zod";
import { TeamId } from "./team-collaboration.js";
export const TeamCallTarget = z.object({ channelId: TeamId }).strict();
export const TeamCallPeerTarget = z.object({ peerId: TeamId }).strict();
export const TeamCallAgentInput = TeamCallTarget.extend({ publicationId: TeamId }).strict();
export const TeamCallAgentTarget = TeamCallTarget.extend({ agentId: TeamId }).strict();
export const TeamCallText = TeamCallTarget.extend({
  text: z.string().trim().min(1).max(4000),
  nonce: z.string().uuid(),
}).strict();
export const TeamCallState = z.object({
  available: z.boolean(),
  canAddAgent: z.boolean(),
  call: z
    .object({
      id: TeamId,
      channelId: TeamId,
      name: z.string(),
      createdAt: z.string(),
      canEnd: z.boolean(),
      people: z.array(z.object({ id: TeamId, userId: TeamId, name: z.string() })),
      agents: z.array(
        z.object({
          id: TeamId,
          publicationId: TeamId,
          name: z.string(),
          canRemove: z.boolean(),
          error: z.string().nullable(),
        }),
      ),
    })
    .nullable(),
});
export const TeamCallConnection = z.object({
  peerId: TeamId,
  callId: TeamId,
  url: z.string(),
  token: z.string(),
  channelName: z.string(),
});
export type TeamCallStateValue = z.infer<typeof TeamCallState>;
